// extracted by mini-css-extract-plugin
module.exports = {"chartInfo":"styles_chartInfo__1rdgG","legends":"styles_legends__3grPr","legendItem":"styles_legendItem__6jgu-"};